function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import getResource from "../../services/resources";
/**
 * Permet d'uploader des fichiers de façon dissimuler à travers un lien ou text (dépendant du composant passé en paramètre)
 *
 * @param [string] resource C'est l'entité au pluriel, ex: communities
 * @param [string] name C'est la propriété sur laquelle on upload
 * @param [object] component C'est le composant visuel pour déclancher l'input file.
 */

var Upload = function Upload(_ref) {
  var component = _ref.component,
      multiple = _ref.multiple,
      resource = _ref.resource,
      name = _ref.name,
      onChange = _ref.onChange,
      subFileSaving = _ref.subFileSaving,
      props = _objectWithoutProperties(_ref, ["component", "multiple", "resource", "name", "onChange", "subFileSaving"]);

  // State
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      file = _useState2[0],
      setFile = _useState2[1];

  var inputRef = useRef(); // Props;

  var Component = component;

  var getFilename = function getFilename(fullPath) {
    var startIndex = fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/');
    var filename = fullPath.substring(startIndex);

    if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
      filename = filename.substring(1);
    }

    return filename;
  };

  var handleFileChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var filename, media, realMedia;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFile(e.target.value);
              filename = getFilename(e.target.value);
              _context.next = 4;
              return getResource('Media').createResource(resource, name, e.currentTarget.files, multiple, subFileSaving, filename);

            case 4:
              media = _context.sent;
              realMedia = null;

              if (multiple) {
                realMedia = [];
                media.map(function (item) {
                  return realMedia.push(item['@id']);
                });
              } else {
                realMedia = media['@id'];
              }

              onChange(realMedia);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFileChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleActiveInput = function handleActiveInput(e) {
    e.preventDefault();
    inputRef.current.click();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "coreUpload"
  }, Component && /*#__PURE__*/React.createElement(Component, {
    onClick: function onClick() {
      return handleActiveInput.apply(void 0, arguments);
    }
  }), /*#__PURE__*/React.createElement("input", _extends({
    type: "file",
    ref: inputRef,
    value: file,
    onChange: handleFileChange,
    hidden: true,
    style: {
      visibility: 'hidden'
    }
  }, props)));
};

Upload.propTypes = {
  component: PropTypes.elementType,
  multiple: PropTypes.bool,
  resource: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
Upload.defaultProps = {
  component: null,
  multiple: false
};
export default Upload;